import { useRecoilCallback } from 'recoil';
import { sidebarStateByType } from '../../store/sidebar.state';
import { actualitySelectedId } from '../store/actuality.state';
import {} from // feedSelectedAgentId,

// feedSelectedPickListId,
'../store/feed.state';

export function useActualityEntityCallbacks() {
  const selectActualityAgent = useRecoilCallback(
    ({ snapshot, set }) =>
      async (agentId: string) => {
        const actualityId = await snapshot.getPromise(actualitySelectedId);

        set(sidebarStateByType('sidebar-feed-main'), current => ({
          ...current,
          isCollapsed: false,
        }));
        set(sidebarStateByType('sidebar-feed-info-event'), current => ({
          ...current,
          isCollapsed: false,
        }));

        // set(feedSelectedAgentId, agentId);
        //set(feedSelectedMenuItemId(actualityId), 'feed-menu-activity'); //TODO: JOTAI
        // set(feedActivitySelectedTabId, 'tab-feed-process');  //TODO: JOTAI
      },
  );

  const selectActualityJob = useRecoilCallback(
    ({ snapshot, set }) =>
      async (agentId: string, jobId: string) => {
        selectActualityAgent(agentId);
        // set(feedSelectedPickListId, jobId);
      },
  );

  return {
    selectActualityAgent,
    selectActualityJob,
  };
}
